import { useLoaderData } from 'react-router-dom';
export const useDynamicConfigs = () => useLoaderData();
